import { useAppStateDispatch } from '@src/providers/AppStateProvider/AppStateProviderHooks';
import { baseRestApi } from '@src/utils/rtkQuery/baseRestApi';
import { useEffect } from 'react';
import { usePrevious } from 'react-use';
import { OrgConfigurationKey, useOrgConfiguration } from '../OrgConfigurationProvider';
import { setCoinMetricsApiKey } from './coinMetricsCredentialsSlice';

/**
 * Syncs the ui.CoinMetricsApiKey org config value into the Redux coinMetricsCredentials slice.
 *
 * Must be rendered inside both:
 *   - AppStateProvider  (needs Redux dispatch)
 *   - OrgConfigurationProvider  (needs getConfig — provided via App.tsx wrapping)
 *
 * Pattern mirrors BlockedSubscriptionsSyncer.ts.
 */
export function CoinMetricsCredentialsSyncer() {
  const dispatch = useAppStateDispatch();
  const { getConfig } = useOrgConfiguration();

  const apiKey = getConfig(OrgConfigurationKey.CoinMetricsApiKey, '');
  const previousApiKey = usePrevious(apiKey);

  useEffect(() => {
    dispatch(setCoinMetricsApiKey(apiKey || null));
    // Skip the initial mount (previousApiKey undefined) — nothing stale to invalidate yet. Long-
    // lived catalog/reference queries don't repoll on their own, so without this a key that was
    // fixed/rotated wouldn't be picked up by already-cached CoinMetrics queries until they expire.
    if (previousApiKey !== undefined && previousApiKey !== apiKey) {
      dispatch(baseRestApi.util.invalidateTags(['CoinMetrics']));
    }
  }, [apiKey, previousApiKey, dispatch]);

  return null;
}
